import type { OTPVerificationResponseDto } from "common/models/api/models/OTPVerificationResponseDto";
import type { VerifyOTPRequest } from "common/models/api/models/VerifyOTPRequest";
import { useMutation, UseMutationResult } from "react-query";
import type { UseCustomMutationOptions } from "ui/query/react-query-overrides";
import { otpApi } from "../api/otpApi";

export default function useVerifyOtp(
    options?: UseCustomMutationOptions<OTPVerificationResponseDto, unknown, VerifyOTPRequest>,
): UseMutationResult<OTPVerificationResponseDto, unknown, VerifyOTPRequest> {
    return useMutation(async (requestBody: VerifyOTPRequest) => {
        const res = await otpApi.verify(requestBody);
        return res.data;
    }, options);
}
